import { apiGet, apiPost, apiPut, apiDelete } from "../../api/client";
import { IProduct } from "../../types";

/**
 * REST client for the `products` resource. Replaces direct Firestore access so
 * product data is read and written exclusively through the API.
 */

const PRODUCTS_PATH = "/api/products/";

/** Serialized product payload sent as a JSON request body (e.g. `Product.data()`). */
type ProductPayload = Record<string, unknown>;

/** Full product list for a workspace (no pagination — current default). */
export const listProducts = async (
  token: string,
  workspaceId: string,
): Promise<IProduct[]> => {
  const envelope = await apiGet(token, PRODUCTS_PATH, workspaceId);
  return (envelope?.data as IProduct[]) ?? [];
};

export const createProduct = async (
  token: string,
  workspaceId: string,
  product: ProductPayload,
): Promise<IProduct> => {
  const envelope = await apiPost(token, PRODUCTS_PATH, product, workspaceId);
  return envelope?.data as IProduct;
};

export const updateProduct = async (
  token: string,
  workspaceId: string,
  productId: string,
  product: ProductPayload,
): Promise<IProduct> => {
  const envelope = await apiPut(
    token,
    `${PRODUCTS_PATH}${productId}`,
    product,
    workspaceId,
  );
  return envelope?.data as IProduct;
};

export const deleteProduct = async (
  token: string,
  workspaceId: string,
  productId: string,
): Promise<void> => {
  await apiDelete(token, `${PRODUCTS_PATH}${productId}`, workspaceId);
};
